/*
    Made by : Samuel
    Date : 21
    Updated: April 23, 2025
 */

// ----------------------------------------------------------------------------- //
// IMPORTS //

import { useContext } from "react";
import { ThemeContext } from "../../../App";
import styles from "./Sponsors.module.css";

// ----------------------------------------------------------------------------- //
// COMPONENT //

function Sponsors() {
    const { isDarkMode } = useContext(ThemeContext);

    return (
        <div className={isDarkMode ? styles.darkTheme : styles.lightTheme}>
            {/* Diamond sponsors - modified to be closer together */}
            <div className={styles.sponsorCategory}>
                <h3
                    className={`text-center ${styles.categoryTitle} ${styles.diamondTitle}`}>
                    Patrocinadores Diamante
                </h3>
                <div
                    className={
                        styles.categoryLine + " " + styles.diamondLine
                    }></div>
                <br />
                <br />
                <br />
                <div className={styles.diamondSponsorsWrapper}>
                    <div className="d-flex justify-content-center">
                        <div
                            className={styles.logoContainer}
                            style={{ margin: "0 10px" }}>
                            <img
                                src="/sponsors/diamond/Lusiaves.svg"
                                className={`${styles.sponsorLogo} ${styles.diamondLogo}`}
                                style={{ width: "400px" }}
                            />
                        </div>
                        <div
                            className={styles.logoContainer}
                            style={{ margin: "0 10px" }}>
                            <img
                                src="/sponsors/diamond/Reina.svg"
                                className={`${styles.sponsorLogo} ${styles.diamondLogo}`}
                                style={{ width: "400px" }}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Gold sponsors */}
            <div className={styles.sponsorCategory}>
                <h3
                    className={`text-center ${styles.categoryTitle} ${styles.goldTitle}`}>
                    Patrocinadores Ouro
                </h3>
                <div
                    className={
                        styles.categoryLine + " " + styles.goldLine
                    }></div>
                <br />
                <div className="row d-flex justify-content-center mt-4">
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center">
                        <div className={styles.logoContainer}>
                            <img
                                src="/sponsors/gold/CSW.svg"
                                className={`${styles.sponsorLogo} ${styles.goldLogo}`}
                                style={{ width: "150px" }}
                            />
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center">
                        <div className={styles.logoContainer}>
                            <img
                                src="/sponsors/gold/Pintogal.png"
                                className={`${styles.sponsorLogo} ${styles.goldLogo}`}
                                style={{ width: "250px", height: "auto" }}
                            />
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center">
                        <div className={styles.logoContainer}>
                            <img
                                src="/sponsors/gold/maxiplas.svg"
                                className={`${styles.sponsorLogo} ${styles.goldLogo}`}
                                style={{ width: "200px" }}
                            />
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center">
                        <div className={styles.logoContainer}>
                            <img
                                src="/sponsors/gold/Roca.svg"
                                className={`${styles.sponsorLogo} ${styles.goldLogo}`}
                                style={{ height: "60px", width: "auto" }}
                            />
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center">
                        <div className={styles.logoContainer}>
                            <img
                                src="/sponsors/gold/santosECordeiro.jpg"
                                className={`${styles.sponsorLogo} ${styles.goldLogo}`}
                                style={{ height: "60px", width: "auto" }}
                            />
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center">
                        <div className={styles.logoContainer}>
                            <img
                                src="/sponsors/gold/htubo.svg"
                                className={`${styles.sponsorLogo} ${styles.goldLogo}`}
                                style={{ height: "200px", width: "auto" }}
                            />
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center">
                        <div className={styles.logoContainer}>
                            <img
                                src="/sponsors/silver/IberOleff.svg"
                                className={`${styles.sponsorLogo} ${styles.goldLogo}`}
                                style={{ height: "125px", width: "auto" }}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Silver sponsors */}
            <div className={styles.sponsorCategory}>
                <h3
                    className={`text-center ${styles.categoryTitle} ${styles.silverTitle}`}>
                    Apoios
                </h3>
                <div
                    className={
                        styles.categoryLine + " " + styles.silverLine
                    }></div>
                <div className="row d-flex justify-content-center mt-4">
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center">
                        <div className={styles.logoContainer}>
                            <img
                                src="/sponsors/silver/cuetara.png"
                                className={`${styles.sponsorLogo} ${styles.silverLogo}`}
                                style={{ width: "75px" }}
                            />
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center">
                        <div className={styles.logoContainer}>
                            <img
                                src="/sponsors/silver/Somotep.svg"
                                className={`${styles.sponsorLogo} ${styles.silverLogo}`}
                                style={{ width: "75px" }}
                            />
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center">
                        <div className={styles.logoContainer}>
                            <img
                                src="/sponsors/silver/SumolCompal.png"
                                className={`${styles.sponsorLogo} ${styles.silverLogo}`}
                                style={{ width: "75px" }}
                            />
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center">
                        <div className={styles.logoContainer}>
                            <img
                                src="/sponsors/silver/SicoPao.png"
                                className={`${styles.sponsorLogo} ${styles.silverLogo}`}
                                style={{ width: "75px" }}
                            />
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center">
                        <div className={styles.logoContainer}>
                            <img
                                src="/sponsors/silver/pizza.png"
                                className={`${styles.sponsorLogo} ${styles.silverLogo}`}
                                style={{ width: "75px" }}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Institutional sponsors */}
            <div className={styles.sponsorCategory}>
                <h3
                    className={`text-center ${styles.categoryTitle} ${styles.institutionalTitle}`}
                    style={{ textAlign: "center" }}>
                    Patrocinadores Institucionais
                </h3>
                <div
                    className={
                        styles.categoryLine + " " + styles.institutionalLine
                    }></div>
                <div className="row d-flex justify-content-center mt-4">
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center">
                        <div className={styles.logoContainer}>
                            <img
                                src="/sponsors/institucionais/2030-1.png"
                                alt="2030"
                                className={`${styles.sponsorLogo} ${styles.institutionalLogo} ${styles.logoHoverEffect}`}
                                style={{ width: "150px" }}
                            />
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center">
                        <div className={styles.logoContainer}>
                            <img
                                src="/sponsors/institucionais/Portugal2030.png"
                                alt="2030"
                                className={`${styles.sponsorLogo} ${styles.institutionalLogo} ${styles.logoHoverEffect}`}
                                style={{ width: "150px" }}
                            />
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center">
                        <div className={styles.logoContainer}>
                            <img
                                src="/sponsors/institucionais/ConfinanciadoPelaUniaoEuropeia.png"
                                alt="2030"
                                className={`${styles.sponsorLogo} ${styles.institutionalLogo} ${styles.logoHoverEffect}`}
                                style={{ width: "150px" }}
                            />
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center">
                        <div className={styles.logoContainer}>
                            <img
                                src="/sponsors/institucionais/2030.png"
                                alt="2030"
                                className={`${styles.sponsorLogo} ${styles.institutionalLogo} ${styles.logoHoverEffect}`}
                                style={{ width: "100px" }}
                            />
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center">
                        <div className={styles.logoContainer}>
                            <img
                                src="/sponsors/institucionais/agrupamento.png"
                                alt="Agrupamento"
                                className={`${styles.sponsorLogo} ${styles.institutionalLogo}`}
                                style={{ width: "150px" }}
                            />
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12 d-flex justify-content-center">
                        <div className={styles.logoContainer}>
                            <img
                                src="/sponsors/institucionais/ClubeCienciaViva.png"
                                alt="Clube Ciência Viva"
                                className={`${styles.sponsorLogo} ${styles.institutionalLogo}`}
                                style={{ width: "150px" }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

// ----------------------------------------------------------------------------- //
// EXPORTS //

export default Sponsors;

// ----------------------------------------------------------------------------- //
